import React, { useEffect, useRef, useState } from "react";

export default function Cursor() {
  const innerRef = useRef(null);
  const outerRef = useRef(null);
  const [hovered, setHovered] = useState(false);

  // Mausbewegung tracken
  useEffect(() => {
    const move = (e) => {
      if (innerRef.current && outerRef.current) {
        innerRef.current.style.left = `${e.clientX}px`;
        innerRef.current.style.top = `${e.clientY}px`;
        outerRef.current.style.left = `${e.clientX}px`;
        outerRef.current.style.top = `${e.clientY}px`;
      }
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  // Hover-Status auf Links tracken
  useEffect(() => {
    const addHover = () => setHovered(true);
    const removeHover = () => setHovered(false);

    // Alle Links auswählen
    const links = document.querySelectorAll("a, button, .cursor-hover");
    links.forEach((link) => {
      link.addEventListener("mouseenter", addHover);
      link.addEventListener("mouseleave", removeHover);
    });
    return () => {
      links.forEach((link) => {
        link.removeEventListener("mouseenter", addHover);
        link.removeEventListener("mouseleave", removeHover);
      });
    };
  }, []);

  return (
    <>
      {/* Äußerer, weicher Glow-Kreis */}
      <div
        ref={outerRef}
        className={`custom-cursor-outer${hovered ? " hovered" : ""}`}
      />
      {/* Innerer, pinker Punkt */}
      <div
        ref={innerRef}
        className={`custom-cursor-inner${hovered ? " hovered" : ""}`}
      />
    </>
  );
}
